export default __webpack_public_path__ + "static/media/etoile-inscrit8.ed6e982f.png";